export const HMS_IFRAME_MESSAGES = {
  authToken: "HMS_AUTH_TOKEN",
  ready: "DISCHARGE_SUMMARY_READY",
  authRequest: "DISCHARGE_SUMMARY_AUTH_REQUEST",
  close: "DISCHARGE_SUMMARY_CLOSE",
  navigate: "DISCHARGE_SUMMARY_NAVIGATE",
};
